import './App.css'; // 👈 import the CSS file




function Landing() {

  const handleClick1 = () => {
    window.location.href = 'https://www.motomuver.com/customer'; // 👈 full page reload
  }
    const handleClick2 = () => {
    window.location.href = 'https://www.motomuver.com/courier'; // 👈 full page reload
  };

  

  return (
    <>
      
        <div className="layout-container">
      <div className="overlay"></div>

      {/* Magenta box */}
      <div className="magenta-box">
        <h1>Motomuver.com</h1>

        <button className="raceButton blue" onClick={handleClick1}>
          Customer Site
        </button>

        <button className="raceButton green" onClick={handleClick2}>
          Courier Site
        </button>
      </div>
    </div>
       
         
     
    </>
  );
}

export default Landing;